<div class="attachment-list">
  @for (item of items(); track item.id) {
    @switch (item.kind) {
      @case ('sticker') {
        @if (urlFor(item.fileId); as url) {
          <img class="attachment-sticker" [src]="url" [alt]="item.filename" loading="lazy" />
        } @else {
          <app-ui-skeleton-row [height]="null" width="8rem" aspectRatio="1 / 1" aria-busy="true" />
        }
      }
      @case ('image') {
        <div class="attachment-item">
          @if (urlFor(item.fileId); as url) {
            <button appUiMediaButton type="button" class="attachment-image" (click)="openLightbox(item.fileId)">
              <img [src]="url" [alt]="item.filename" loading="lazy" />
            </button>
          } @else {
            <app-ui-skeleton-row [height]="null" width="18rem" aspectRatio="4 / 3" aria-busy="true" />
          }
          @if (item.analysisBadge; as badge) {
            @if (badge.href) {
              <a appBadge [tone]="badge.tone" [routerLink]="badge.href" class="attachment-item__badge">{{ badge.label }}</a>
            } @else {
              <span appBadge [tone]="badge.tone" class="attachment-item__badge">{{ badge.label }}</span>
            }
          }
        </div>
      }
      @case ('video') {
        <div class="attachment-item">
          @if (urlFor(item.fileId); as url) {
            <video class="attachment-media" controls preload="metadata" [src]="url"></video>
          } @else {
            <app-ui-skeleton-row [height]="null" width="22rem" aspectRatio="16 / 9" aria-busy="true" />
          }
          @if (item.analysisBadge; as badge) {
            @if (badge.href) {
              <a appBadge [tone]="badge.tone" [routerLink]="badge.href" class="attachment-item__badge">{{ badge.label }}</a>
            } @else {
              <span appBadge [tone]="badge.tone" class="attachment-item__badge">{{ badge.label }}</span>
            }
          }
        </div>
      }
      @case ('audio') {
        @if (urlFor(item.fileId); as url) {
          <div class="audio-message">
            <app-audio-player [src]="url" />
            <app-audio-transcription [fileId]="item.fileId" />
          </div>
        } @else {
          <app-ui-skeleton-row [height]="40" width="18rem" aria-busy="true" />
        }
      }
      @default {
        @if (urlFor(item.fileId); as url) {
          <a appUiPanelCard class="attachment-doc" [href]="url" target="_blank" rel="noopener">
            <ng-icon name="heroDocument" size="20" aria-hidden="true" />
            <span class="attachment-doc__info">
              <span class="attachment-doc__name">{{ item.filename }}</span>
              <span class="attachment-doc__size">{{ item.size }}</span>
            </span>
            <ng-icon name="heroArrowDownTray" size="16" aria-hidden="true" />
          </a>
        } @else {
          <div appUiPanelCard class="attachment-doc attachment-doc--loading" aria-busy="true">
            <ng-icon name="heroDocument" size="20" aria-hidden="true" />
            <span class="attachment-doc__info">
              <span class="attachment-doc__name">{{ item.filename }}</span>
              <span class="attachment-doc__size">{{ item.size }}</span>
            </span>
          </div>
        }
        @if (item.analysisBadge; as badge) {
          @if (badge.href) {
            <a appBadge [tone]="badge.tone" [routerLink]="badge.href" class="attachment-doc__badge">{{ badge.label }}</a>
          } @else {
            <span appBadge [tone]="badge.tone" class="attachment-doc__badge">{{ badge.label }}</span>
          }
        }
      }
    }
  }
</div>

@if (lightboxUrl(); as url) {
  <div class="attachment-lightbox" role="dialog" aria-modal="true" aria-label="Anexo ampliado">
    <button appUiBackdropButton type="button" class="attachment-lightbox__backdrop" aria-label="Fechar" (click)="closeLightbox()"></button>
    <button type="button" appUiIconButton variant="soft" shape="pill" size="md" class="attachment-lightbox__close" aria-label="Fechar" (click)="closeLightbox()">
      <ng-icon name="heroXMark" size="22" aria-hidden="true" />
    </button>
    <img class="attachment-lightbox__image" [src]="url" alt="Anexo ampliado" />
  </div>
}
